import { Box, TableCell, Typography } from '@material-ui/core'

import { IListItemProps } from '../../types'
import { useStyles } from './style'

const TableCellWithLabel = ({ name, value, withoutName }: IListItemProps) => {
  const classes = useStyles()

  if (withoutName)
    return (
      <TableCell className={classes.main}>
        <Box className={classes.listItemWithoutName}>
          <Typography className={classes.label} />
          <Typography className={classes.listValue}>{value}</Typography>
        </Box>
      </TableCell>
    )

  return (
    <TableCell className={classes.main}>
      <Box className={classes.listItem}>
        <Typography className={classes.label}>{`${name}:`}</Typography>
        <Typography className={classes.listValue}>{value}</Typography>
      </Box>
    </TableCell>
  )
}

export default TableCellWithLabel
